import { Text } from '@chakra-ui/react';
import type { Msg } from '@halo/chat-sdk-react';
import { Fragment } from 'react';
import { MyTrans } from '@halo/ui-react';
import { useUserInfoList } from '@/scripts/hooks/useUserInfoList';
import { useUserInfo } from '@/scripts/hooks';
import { MsgUserText } from '../../msg-parts';

export interface MsgGroupUpdateJoinContentProps {
  message: Msg;
}

export const MsgGroupUpdateJoinContent = memo(function MsgGroupUpdateJoinContent({
  message,
}: MsgGroupUpdateJoinContentProps) {
  const { user_ids, user_id } = message.payload;
  const { user: joinUser } = useUserInfo(user_ids?.length ? undefined : user_id); // for MsgPayloadType.GROUP_UPDATE_JOIN
  const { users: joinUsers } = useUserInfoList(user_ids); //for MsgPayloadType.GROUP_JOIN_SUCCESS

  const users = useMemo(() => {
    const addUser = [];
    if (joinUser) {
      addUser.push(joinUser);
    }
    if (joinUsers) {
      addUser.push(...joinUsers);
    }
    return addUser;
  }, [joinUser, joinUsers]);

  return (
    <MyTrans
      i18nKey="chat.groupMessageJoinText"
      components={{
        members: (
          <Text as="span" color="fg.muted">
            {users?.map((user, index) => (
              <Fragment key={user?.user_id || index}>
                {index > 0 && ', '}
                <MsgUserText userName={user?.name || ''} userId={user?.user_id || ''} />
              </Fragment>
            ))}
          </Text>
        ),
      }}
    ></MyTrans>
  );
});
